// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"223":"faffc18d","270":"aad9811c","307":"7f52d771","535":"b4dde816","545":"0c72850d","568":"ef0cb701","620":"94203cf6","707":"4c68f890","907":"f06875d5"}[chunkId] + ".chunk.css";
};